import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThirdPartyLoaderComponent } from '@features/third-party/third-party-loader/third-party-loader.component';
import { AdtractionComponent } from './adtraction/adtraction.component';
import { MetaLiveShoppingComponent } from './meta-live-shopping/meta-live-shopping.component';
import { IframeLoaderComponent } from './iframe-loader/iframe-loader.component';
import { SharedModule } from '@shared/shared.module';
import { ParseStylePipe } from './iframe-loader/parse-style.pipe';

@NgModule({
    imports: [CommonModule, SharedModule, ThirdPartyLoaderComponent, AdtractionComponent, MetaLiveShoppingComponent, IframeLoaderComponent, ParseStylePipe],
    exports: [ThirdPartyLoaderComponent, AdtractionComponent, MetaLiveShoppingComponent, IframeLoaderComponent]
})
export class ThirdPartyModule {}
